/*------------------------------------*\
	#SWIPER
\*------------------------------------*/

const initSwiper = () => {
	const selectorSwiperImageCarousel = '.js-swiper--image-carousel';
	const isImageCarouselAvailable = document.querySelector(selectorSwiperImageCarousel);

	const selectorSwiperContentSlider = '.js-swiper--content-slider';
	const isContentSliderAvailable = document.querySelector(selectorSwiperContentSlider);

	const selectorSwiperBonusteaserSlider = '.js-swiper--bonusteaser-slider';
	const isBonusteaserSliderAvailable = document.querySelector(selectorSwiperBonusteaserSlider);

	if (isImageCarouselAvailable) {
		const swiperCarousel = new Swiper(selectorSwiperImageCarousel, {

			// Optional parameters
			grabCursor: true,
			effect: "fade",
			autoplay: {
				delay: 7500,
				disableOnInteraction: false,
			},
			loop: true,
			disableOnInteraction: false,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

		});
	}

	if (isContentSliderAvailable) {
		const swiperContentSlider = new Swiper(selectorSwiperContentSlider, {

			// Optional parameters
			grabCursor: true,
			effect: "fade",
			autoplay: {
				delay: 7500,
				disableOnInteraction: false,
			},
			loop: true,
			disableOnInteraction: false,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			// Navigation arrows
			navigation: {
				enabled: true,
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		});
	}

	if (isBonusteaserSliderAvailable) {
		const swiperBonusteaserSlider = new Swiper(selectorSwiperBonusteaserSlider, {

			// Optional parameters
			grabCursor: true,
			effect: "fade",
			autoHeight: true,
			autoplay: false,
			rewind: true,
			disableOnInteraction: false,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

		});

	}

}

window.addEventListener('DOMContentLoaded', (event) => {
	initSwiper();
});
